const sliderImageSwiperBlocks = document.querySelectorAll(
    '.swiper__slider_block'
);

if (sliderImageSwiperBlocks) {
    for (var i = sliderImageSwiperBlocks.length - 1; i >= 0; i--) {
        const swiperID = '#' + sliderImageSwiperBlocks[i].getAttribute('id');

        let nextID = swiperID + '_control_next';
        let prevID = swiperID + '_control_prev';

        let swiper = new Swiper(swiperID, {
            loop: false,
            watchOverflow: true,
            navigation: {
                nextEl: nextID,
                prevEl: prevID,
            },
        });
    }
}

const contactBarSwiperDOM = document.getElementById('swiper__contactBar');
if (contactBarSwiperDOM) {
    let sO = {
        slidesPerView: 4,
        breakpoints: {
            768: {
                slidesPerView: 1,
            },
        },
        navigation: {
            nextEl: '#swiper__contactBar_control_next',
            prevEl: '#swiper__contactBar_control_prev',
        },
    };
    let contactBarSwiper = new Swiper('#swiper__contactBar', sO);
}
